import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg width="16" className={className} height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 0C12.4418 0 12.8 0.358176 12.8 0.8V4H15.2C15.6418 4 16 4.35818 16 4.8V12.8C16 13.2418 15.6418 13.6 15.2 13.6H12.8V15.2C12.8 15.6418 12.4418 16 12 16H4C3.55818 16 3.2 15.6418 3.2 15.2V13.6H0.8C0.358176 13.6 0 13.2418 0 12.8V4.8C0 4.35818 0.358176 4 0.8 4H3.2V0.8C3.2 0.358176 3.55818 0 4 0H12ZM11.2 12H4.8V14.4H11.2V12ZM14.4 5.6H1.6V12H3.2V11.2C3.2 10.7582 3.55818 10.4 4 10.4H12C12.4418 10.4 12.8 10.7582 12.8 11.2V12H14.4V5.6ZM4.8 6.4V8H2.4V6.4H4.8ZM11.2 1.6H4.8V4H11.2V1.6Z"
      fill="#090909"
    />
  </svg>
);

export default Icon;
